/**
 * custom.js — Vendor customization entry point
 * ---------------------------------------------------------------------------
 * This file is YOURS to edit. It is plain JavaScript: no build step, no
 * compiler. Edit it directly in the Shopify code editor or in your repo and
 * deploy. It loads after the theme's own bundle, so the theme's public API is
 * available on `window.STOREFRONT`.
 *
 * Do NOT edit the hashed bundles (storefront-*.js, sectionRegistry-*.js) or
 * anything under assets/ that has a -[hash] suffix — those are generated.
 *
 * Public API (window.STOREFRONT):
 *   .ready(cb)               Run cb once the theme has finished initializing.
 *   .on(eventName, cb)       Listen to a theme event. Returns an unsubscribe fn.
 *   .EVENTS                  Map of event-name constants (see EVENTS.md).
 *   .events                  EventTarget for theme-level custom events.
 *   .onPubsubReady(cb)       Run cb once window.theme.pubsub is available
 *                            (use for variant changes via the base theme).
 *
 * See EVENTS.md for the full event catalog and payloads.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  /**
   * Your code goes here. `STOREFRONT` is window.STOREFRONT, guaranteed to exist
   * with its public API attached by the time this runs.
   */
  function init(STOREFRONT) {
    // ---- Example 1: run code after the theme is fully initialized ----------
    STOREFRONT.ready(function () {
      // console.log('Theme ready — safe to query the DOM and theme state.');
    });

    // ---- Example 2: react to add-to-cart -----------------------------------
    // const off = STOREFRONT.on(STOREFRONT.EVENTS.ajaxProductAdded, function (event) {
    //   const product = event.detail && event.detail.product;
    //   // ... your logic ...
    // });
    // Call off() to stop listening.

    // ---- Example 3: react to cart updates ----------------------------------
    // STOREFRONT.on(STOREFRONT.EVENTS.cartUpdated, function (event) {
    //   const cart = event.detail && event.detail.cart;
    // });

    // ---- Example 4: react to variant changes (via base-theme pubsub) -------
    // STOREFRONT.onPubsubReady(function () {
    //   const pubsub = window.theme.pubsub;
    //   pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, function (data) {
    //     const variant = data && data.data && data.data.variant;
    //   });
    // });
  }

  // Bootstrap: wait until the theme bundle has attached its public API,
  // then hand control to init(). No fixed timeouts — retries on each frame.
  (function boot() {
    if (!window.STOREFRONT || typeof window.STOREFRONT.ready !== 'function') {
      window.requestAnimationFrame(boot);
      return;
    }
    init(window.STOREFRONT);
  })();
})();
